import { Image } from 'antd';
import { useState, forwardRef, useImperativeHandle } from 'react';
import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import errImgage from '@/assets/images/usual/errImg.webp';
const PreviewImg = ({ src, className, errClassName, style, width, height, canClickImage = true, errImg }, ref) => {
    const [isError, setIsError] = useState(false);
    const [visible, setVisible] = useState(false);
    useImperativeHandle(ref, () => {
        return {
            setVisible
        };
    });
    const clickImage = () => {
        if (!canClickImage) {
            return;
        }
        setVisible(true);
    };
    const onError = () => {
        setIsError(true);
    };
    return (
        <>
            <Display show={!isError}>
                <img
                    onClick={clickImage}
                    className={`${s['preview-img']} ${className}`}
                    src={src}
                    style={style}
                    width={width}
                    height={height}
                    onError={onError}
                />
            </Display>
            <Display show={isError}>
                <div className={`${s['err-img-wrap']} ${errClassName}`} src={errImg}>
                    <img src={errImgage || errImg} />
                </div>
            </Display>
            <Image
                style={{
                    display: 'none'
                }}
                preview={{
                    visible,
                    src,
                    onVisibleChange: (value) => {
                        setVisible(value);
                    }
                }}
            ></Image>
        </>
    );
};

export default forwardRef(PreviewImg);
